import { render, staticRenderFns } from "./Empresa.vue?vue&type=template&id=ff6a74ce&scoped=true&"
import script from "./Empresa.vue?vue&type=script&lang=js&"
export * from "./Empresa.vue?vue&type=script&lang=js&"
import style0 from "./Empresa.vue?vue&type=style&index=0&id=ff6a74ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6a74ce",
  null
  
)

export default component.exports